/* Z-Stack offer page. Generated by shopify/build-zso.py. Do not hand-edit. */
(function(){
  var zso=document.getElementById('zso');if(!zso)return;
  // phones and tablets always open at the top: no jump to #order, no restored scroll position
  if(matchMedia('(max-width:980px)').matches){
    if('scrollRestoration' in history)history.scrollRestoration='manual';
    if(location.hash)history.replaceState(null,'',location.pathname+location.search);
    var touched=false;['touchstart','wheel','keydown'].forEach(function(t){addEventListener(t,function(){touched=true},{once:true,passive:true})});
    scrollTo(0,0);addEventListener('load',function(){if(!touched)scrollTo(0,0)});
  }
  // in-page links scroll smoothly without leaving a #hash behind
  zso.querySelectorAll('a[href^="#"]').forEach(function(a){a.addEventListener('click',function(e){var t=zso.querySelector(a.getAttribute('href'));if(!t)return;e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'})})});
  // buy box: the chosen option expands to show its details, button and phone number
  zso.querySelectorAll('input[name="plan"]').forEach(function(r){
    r.addEventListener('change',function(){
      zso.querySelectorAll('.zso-buy .zso-opt').forEach(function(o){o.classList.toggle('zso-on',o.contains(r))});
    });
  });
  // buy box keeps the height of its tallest state (autoship open) so the hero doesn't jump when switching options
  var buyBox=document.getElementById('buy'),buyOpts=[].slice.call(buyBox.querySelectorAll('.zso-opt'));
  function lockBuy(){buyBox.style.minHeight='';var cur=buyOpts.map(function(o){return o.classList.contains('zso-on')}),max=0;buyOpts.forEach(function(o){buyOpts.forEach(function(p){p.classList.toggle('zso-on',p===o)});max=Math.max(max,buyBox.offsetHeight)});buyOpts.forEach(function(o,i){o.classList.toggle('zso-on',cur[i])});buyBox.style.minHeight=max+'px'}
  window.zsoLockBuy=lockBuy;lockBuy();addEventListener('resize',lockBuy);if(document.fonts&&document.fonts.ready)document.fonts.ready.then(lockBuy);
  // header CTA lines up with the buy box's right edge (the box can extend past the column so its title stays on one line)
  var hdrBtn=zso.querySelector('.zso-site-header .zso-btn-gold'),hdrWrap=zso.querySelector('.zso-site-header .zso-wrap');
  function alignHdr(){if(!hdrBtn)return;hdrBtn.style.marginRight='';var d=buyBox.getBoundingClientRect().right-hdrWrap.getBoundingClientRect().right;hdrBtn.style.marginRight=d>0?(-Math.round(d))+'px':''}
  alignHdr();addEventListener('resize',alignHdr);if(document.fonts&&document.fonts.ready)document.fonts.ready.then(alignHdr);
  // headline fills its column on one line: measure at a known size, scale to the column width
  var h1=document.getElementById('hero-title');
  function fitH1(){h1.style.fontSize='100px';var w=h1.parentElement.clientWidth,tw=h1.scrollWidth;if(!w||!tw)return;h1.style.fontSize=Math.min(96,Math.floor(100*w/tw*10)/10)+'px'}
  fitH1();addEventListener('resize',fitH1);if(document.fonts&&document.fonts.ready)document.fonts.ready.then(fitH1);
  // Scroll-driven 360 spin: the label is unwrapped onto a cylinder texture
  // (assets/spin/tex.webp) and re-lit with the photo's own lighting strip.
  var G={cx:241,R:198,xl:43,y0:240,h:529,texW:1440,edge:6};
  var cv=document.getElementById('spin'),box=cv&&cv.parentNode;
  if(cv&&cv.getContext){
    var load=function(src){return new Promise(function(ok,no){var i=new Image();i.onload=function(){ok(i)};i.onerror=no;i.src=src})};
    Promise.all([load(zso.dataset.spinBase),load(zso.dataset.spinTex),load(zso.dataset.spinLight)]).then(function(im){
      var base=im[0],tex=im[1],light=im[2],ctx=cv.getContext('2d'),lw=light.width;
      var band=document.createElement('canvas');band.width=lw;band.height=G.h;var bx=band.getContext('2d');
      var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var cur=0,target=0,raf=0;
      function draw(phi){
        bx.globalCompositeOperation='source-over';
        for(var i=0;i<lw;i++){
          var s=(G.xl+i+.5-G.cx)/G.R; s=s<-1?-1:s>1?1:s;
          var u=((Math.asin(s)+phi)/(2*Math.PI)+.5)*G.texW; u=((u%G.texW)+G.texW)%G.texW;
          bx.drawImage(tex,Math.min(u,G.texW-1),0,1,G.h,i,0,1,G.h);
        }
        bx.globalCompositeOperation='multiply';
        bx.drawImage(light,0,0,lw,1,0,0,lw,G.h);
        ctx.clearRect(0,0,cv.width,cv.height);
        ctx.drawImage(base,0,0);
        ctx.drawImage(band,G.edge,0,lw-2*G.edge,G.h,G.xl+G.edge,G.y0,lw-2*G.edge,G.h);
      }
      function progress(){
        var gal=box.parentNode,next=zso.querySelector('.zso-hero').nextElementSibling;
        var wide=matchMedia('(min-width:981px)').matches,gr=gal.getBoundingClientRect();
        var end=wide?next.offsetTop-innerHeight*.55:gr.bottom+scrollY-innerHeight*.15;
        var p=scrollY/Math.max(end,1);return p<0?0:p>1?1:p;
      }
      function tick(){
        cur+=(target-cur)*.12;
        if(Math.abs(target-cur)<.0005)cur=target;
        draw(cur);
        raf=cur===target?0:requestAnimationFrame(tick);
      }
      function onScroll(){
        target=progress()*2*Math.PI;
        if(!raf)raf=requestAnimationFrame(tick);
      }
      draw(0);box.classList.add('zso-ready');
      if(!reduce){addEventListener('scroll',onScroll,{passive:true});addEventListener('resize',onScroll);onScroll();}
    }).catch(function(){});
  }

  // ---- motion: guided story ----
  var calm=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var bar=document.getElementById('buybar'),barCta=document.getElementById('buybar-cta');
  if('IntersectionObserver' in window){
    var buyVis=true,buyBox=document.getElementById('buy');
    var syncBar=function(){var on=!buyVis&&buyBox.getBoundingClientRect().bottom<0;bar.classList.toggle('zso-show',on);bar.setAttribute('aria-hidden',on?'false':'true');barCta.tabIndex=on?0:-1};
    new IntersectionObserver(function(e){buyVis=e[0].isIntersecting;syncBar()}).observe(buyBox);
  }
  if(!calm&&'IntersectionObserver' in window){
    var root=zso;
    var groups=[['.zso-section .zso-head',''],['.zso-day li',''],['.zso-ingr-cards li',''],['.zso-together',''],['.zso-compare-note',''],
      ['.zso-quotes blockquote','fan'],['.zso-quotes-note',''],['.zso-faq details',''],['.zso-label','']];
    groups.forEach(function(g){zso.querySelectorAll(g[0]).forEach(function(el,i){el.setAttribute('data-reveal',g[1]);el.style.setProperty('--i',i%6)})});
    var compare=zso.querySelector('.zso-compare');compare.setAttribute('data-reveal','');
    zso.querySelectorAll('.zso-badge-ico .zso-ico *').forEach(function(n){n.setAttribute('pathLength','1')});
    root.classList.add('zso-motion');
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;e.target.classList.add('zso-in');io.unobserve(e.target);
      if(e.target===compare)countUp()})},{rootMargin:'0px 0px -12% 0px',threshold:.15});
    // ingredient cards start revealing just inside the bottom of the screen
    var late=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;e.target.classList.add('zso-in');late.unobserve(e.target)})},{rootMargin:'0px 0px -7% 0px',threshold:.15});
    zso.querySelectorAll('[data-reveal]').forEach(function(el){(el.closest('.zso-ingr-cards')?late:io).observe(el)});
    // "Separately" total counts up to $70 - $125
    function countUp(){var cell=compare.querySelector('tfoot td:last-child'),t0=null;
      function f(t){if(!t0)t0=t;var k=Math.min((t-t0)/900,1),e=1-Math.pow(1-k,3);
        cell.textContent='$'+Math.round(70*e)+' - $'+Math.round(125*e);if(k<1)requestAnimationFrame(f)}
      requestAnimationFrame(f)}
    // scroll-scrubbed moments: autoship flow + ingredient stack + zinc into cell
    var flow=zso.querySelector('.zso-flow'),steps=flow.children;
    var stackFig=zso.querySelector('.zso-stack-fig'),smalls=stackFig.querySelectorAll('.zso-small'),flows=stackFig.querySelectorAll('.zso-flows path'),heroB=stackFig.querySelectorAll('.zso-hero-b'),tags=stackFig.querySelectorAll('.zso-tags'),zin=zso.querySelector('.zso-mech .zso-zin');
    var clamp=function(v){return v<0?0:v>1?1:v};
    var prog=function(el,a,b){var r=el.getBoundingClientRect(),h=innerHeight;return clamp((h*a-r.top)/(h*(a-b)))};
    var ticking=false;
    function scrub(){ticking=false;
      // flow: 0 when the list's top is at 85% of the viewport, 1 when it reaches 35%
      var p=prog(flow,.85,.35);
      var seg=[[0,.08],[.08,.5],[.5,.92]];
      for(var i=0;i<steps.length;i++){
        steps[i].classList.toggle('zso-lit',p>=seg[i][0]+.02||p>=.999);
        if(i<steps.length-1){var c=clamp((p-seg[i+1][0])/(seg[i+1][1]-seg[i+1][0]));steps[i].style.setProperty('--c',c.toFixed(3));steps[i].style.setProperty('--a',c>.97?1:0)}
      }
      // four bottles -> one: bottles appear, lines draw, then the Z-Stack bottle lands
      var q=prog(stackFig,.75,.2),ease=function(k){return 1-Math.pow(1-clamp(k),3)};
      smalls.forEach(function(g,i){var e=ease(q*4-(i%4)*.35);g.style.opacity=e.toFixed(3);g.style.transform='translateX('+((1-e)*-14).toFixed(1)+'px)'});
      flows.forEach(function(f,i){f.style.strokeDashoffset=(1-ease(q*2.2-.45-(i%4)*.08)).toFixed(3)});
      var eb=ease(q*2.5-1.25),et=ease(q*3-2).toFixed(3);heroB.forEach(function(b){b.style.opacity=eb.toFixed(3);b.style.transform='scale('+(.9+.1*eb).toFixed(3)+')'});
      tags.forEach(function(t){t.style.opacity=et});
      var z=prog(zin.ownerSVGElement,.7,.3),ez=1-Math.pow(1-z,3);
      zin.style.transform='translateX('+((1-ez)*-210).toFixed(1)+'px)';zin.style.opacity=(.2+.8*ez).toFixed(3);
    }
    var onS=function(){if(!ticking){ticking=true;requestAnimationFrame(scrub)}};
    addEventListener('scroll',onS,{passive:true});addEventListener('resize',onS);scrub();
  }
})();
